import '@fontsource/nunito/300.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import { theme } from '@zappyrent/hundop';
import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';

export const AppGlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  ${normalize()}

  html {
    color: ${theme.colors.mainAlternate};
    font-family: ${theme.fonts.body};
    font-size: 1em;
    font-weight: 400;
    line-height: 140%;
    background-color: ${theme.colors.main};
    scroll-behavior: smooth;
  }

  body {
    overflow-x: hidden;

    &.prevent-scroll {
      height: 100vh;
      overflow: hidden;
    }
  }

  #toast {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    display: flex;
    flex-direction: column-reverse;

  }

  &:-webkit-autofill::first-line,
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    font-family: ${theme.fonts.body};
    -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
    -webkit-transition-delay: 9999s;
    transition: color 9999s ease-out, background-color 9999s ease-out;
    transition-delay: 9999s;
  }
`;
